import * as React from "react";
import { Wrapper } from "./components/Wrapper";

export interface IBaseSVG {
  children?: any;
  viewBox: string;
}

export const BaseSVG = ({ children, ...props }: IBaseSVG) => (
  <Wrapper {...props}>{children}</Wrapper>
);
